import * as React from 'react';
export const panelArrowLeftSvg = React.forwardRef(
  function panelArrowLeftSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M10.75 1a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 .75-.75Zm-5.22.22a.75.75 0 0 1 0 1.06L2.56 5.25h5.69a.75.75 0 0 1 0 1.5H2.56l2.97 2.97a.75.75 0 1 1-1.06 1.06L.22 6.53a.748.748 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z',
      }),
    );
  },
);
panelArrowLeftSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var panelArrowLeft = {
  category: 'icon',
  colorable: true,
  name: 'panelArrowLeft',
  svg: panelArrowLeftSvg,
};
